import { User } from 'src/auth'
import { GridEntity } from '../query/types'
import { Dictionary } from 'lodash'

const GLOBAL_SET_DRAWER = 'app/global/SETDRAWER'
const GLOBAL_CHANGE_PAGE = 'app/global/CHANGEPAGE'
const GLOBAL_NAVIGATE = 'app/global/NAVIGATE'
const GLOBAL_CHANGE_TITLE = 'app/global/CHANGETITLE'
const GLOBAL_CHANGE_URL = 'app/global/CHANGEURL'
const GLOBAL_LOGIN_START = 'app/global/LOGINSTART'
const GLOBAL_LOGIN_FAIL = 'app/global/LOGINFAIL'
const GLOBAL_LOGIN_SUCCESS = 'app/global/LOGINSUCCESS'
const GLOBAL_LOGOUT_START = 'app/global/LOGOUTSTART'
const GLOBAL_LOGOUT_END = 'app/global/LOGOUTEND'
const GLOBAL_ADD_SNACKBAR = 'app/global/ADDSNACKBAR'
const GLOBAL_CLOSE_SNACKBAR = 'app/global/CLOSESNACKBAR'
const GLOBAL_REMOVE_SNACKBAR = 'app/global/REMOVESNACKBAR'
const GLOBAL_SHOW_MODAL = 'app/global/SHOWMODAL'
const GLOBAL_HIDE_MODAL = 'app/global/HIDEMODAL'
const GLOBAL_LOAD_GRIDS = 'app/global/LOAD_GRIDS'
const GLOBAL_SET_GRIDS = 'app/global/SET_GRIDS'
const GLOBAL_REMOVE_GRID = 'app/global/GLOBAL_REMOVE_GRID' // remove grid from local store
const GLOBAL_ADD_GRID = 'app/global/GLOBAL_ADD_GRID' // add grid to local store

export {
    GLOBAL_SET_DRAWER,
    GLOBAL_CHANGE_PAGE,
    GLOBAL_NAVIGATE,
    GLOBAL_CHANGE_TITLE,
    GLOBAL_CHANGE_URL,
    GLOBAL_LOGIN_FAIL,
    GLOBAL_LOGIN_START,
    GLOBAL_LOGIN_SUCCESS,
    GLOBAL_LOGOUT_START,
    GLOBAL_LOGOUT_END,
    GLOBAL_ADD_SNACKBAR,
    GLOBAL_CLOSE_SNACKBAR,
    GLOBAL_REMOVE_SNACKBAR,
    GLOBAL_SHOW_MODAL,
    GLOBAL_HIDE_MODAL,
    GLOBAL_LOAD_GRIDS,
    GLOBAL_SET_GRIDS,
    GLOBAL_REMOVE_GRID,
    GLOBAL_ADD_GRID
}

export interface GlobalViewState {
    drawerOpen: boolean
    pageTitle: string
    notifications: Notification[]
}

export interface GlobalGridsState {
    grids: Dictionary<Dictionary<GridEntity>>
}

export interface Notification {
    message: string
    key: string
    dismissed: boolean
    options: any
}

export interface GlobalOptionsState {
    baseUrl: string | null
}

export interface GlobalModalState {
    modalType: Modals | null
    modalProps: any
}


export enum Modals {
    GenericConfirm
}

interface DrawerChangeStateAction {
    type: typeof GLOBAL_SET_DRAWER
    open: boolean
}

export interface ChangePageAction {
    type: typeof GLOBAL_CHANGE_PAGE
    route: string
    search?: string
}

export interface NavigateAction {
    type: typeof GLOBAL_NAVIGATE
    route: string
}

interface ChangeTitleAction {
    type: typeof GLOBAL_CHANGE_TITLE
    title: string
}

interface AddSnackbarAction {
    type: typeof GLOBAL_ADD_SNACKBAR,
    notification: Notification
}

interface RemoveSnackbarAction {
    type: typeof GLOBAL_REMOVE_SNACKBAR,
    key: string
}

interface CloseSnackbarAction {
    type: typeof GLOBAL_CLOSE_SNACKBAR,
    key: string
}

export type GlobalViewActionTypes =
    | DrawerChangeStateAction
    | ChangePageAction
    | NavigateAction
    | ChangeTitleAction
    | AddSnackbarAction | RemoveSnackbarAction | CloseSnackbarAction

interface ChangeBaseUrlAction {
    type: typeof GLOBAL_CHANGE_URL
    url: string
}

export type GlobalOptionsActionTypes = ChangeBaseUrlAction


export interface GlobalLoginState {
    token: OAuthToken | null
}

export const AuthEndpoints = {
    Login: '/token',
    ResetPassword: '/changepassword',
    Logout: '/logout'
}

interface LoginStartAction {
    type: typeof GLOBAL_LOGIN_START
    username: string
    password: string
}

interface LoginFailAction {
    type: typeof GLOBAL_LOGIN_FAIL
}

export interface LoginSuccessAction {
    type: typeof GLOBAL_LOGIN_SUCCESS
    token: OAuthToken
}

interface LogoutStartAction {
    type: typeof GLOBAL_LOGOUT_START
}

interface LogoutEndAction {
    type: typeof GLOBAL_LOGOUT_END
}

export interface OAuthToken {
    access_token: string
    token_type: string
    expires_in: number
    user: User
}

export type GlobalAuthActionTypes = LoginStartAction | LoginFailAction | LoginSuccessAction | LogoutStartAction | LogoutEndAction

export interface GlobalLoadGridsAction {
    type: typeof GLOBAL_LOAD_GRIDS
    resourceNames: string[]
}

export interface GlobalRemoveGridAction {
    type: typeof GLOBAL_REMOVE_GRID
    id: string
}

export interface GlobalAddGridAction {
    type: typeof GLOBAL_ADD_GRID
    grid: GridEntity
}

export interface GlobalSetGridsAction {
    type: typeof GLOBAL_SET_GRIDS
    grids: Dictionary<Dictionary<GridEntity>>
}

export type GlobalGridsActionTypes = GlobalLoadGridsAction | GlobalSetGridsAction | GlobalRemoveGridAction | GlobalAddGridAction;

export interface Response<T> {
    body: T
    status: number
}
